export interface State {
  message: string | null
}

export const initialState: State = {
  message: null,
}
